export default __webpack_public_path__ + "assets/glyphicons-halflings-regular.4692b9ec53fd5972caa2f2372ae20d16.ttf";